import { FormArray, FormGroup } from '@angular/forms';

import type { PendingDropdownItem, RepeatableLogger, RepeatableResolutionResult } from './repeatable-group.types';
import { RepeatableDropdownResolver } from './repeatable-dropdown.resolver';

export class RepeatablePendingDropdownResolver {
    public constructor(
        private readonly dropdownResolver: RepeatableDropdownResolver,
        private readonly logger: RepeatableLogger,
    ) {}

    public resolvePending(rowsArray: FormArray<FormGroup>, pendingDropdown: PendingDropdownItem[]): RepeatableResolutionResult {
        const stillPending: PendingDropdownItem[] = [];
        const resolvedChanges: RepeatableResolutionResult['resolvedChanges'] = [];
        let didResolveAny = false;

        for (const item of pendingDropdown) {
            const rowGroup = rowsArray.at(item.rowIndex);
            const control = rowGroup?.get(item.logicalKey);

            if (!control) {
                this.logger.warn('tryResolvePending(): control missing.', { item });
                continue;
            }

            if (!item.isMulti) {
                const id = item.rawIds[0] ?? '';
                const selectedValue = this.dropdownResolver.mapIdToDropdownValue(id, item.sf, item.rowIndex);

                if (selectedValue !== null && selectedValue !== undefined) {
                    const previousValue = control.value;
                    control.patchValue(selectedValue, { emitEvent: false });
                    didResolveAny = true;
                    resolvedChanges.push({
                        rowIndex: item.rowIndex,
                        logicalKey: item.logicalKey,
                        previousValue,
                        currentValue: selectedValue,
                    });
                } else {
                    stillPending.push(item);
                }

                continue;
            }

            const currentValue = Array.isArray(control.value) ? (control.value as unknown[]) : [];
            const resolvedNow = item.rawIds
                .map((id) => this.dropdownResolver.mapIdToDropdownValue(id, item.sf, item.rowIndex))
                .filter((value) => value !== null && value !== undefined);

            if (resolvedNow.length > 0) {
                const previousValue = control.value;
                const nextValue = [...currentValue, ...resolvedNow];

                control.patchValue(nextValue, { emitEvent: false });
                didResolveAny = true;
                resolvedChanges.push({
                    rowIndex: item.rowIndex,
                    logicalKey: item.logicalKey,
                    previousValue,
                    currentValue: nextValue,
                });
            }

            const unresolvedIds = item.rawIds.filter((id) =>
                this.dropdownResolver.mapIdToDropdownValue(id, item.sf, item.rowIndex) === null
            );

            if (unresolvedIds.length > 0) {
                stillPending.push({ ...item, rawIds: unresolvedIds });
            }
        }

        return { stillPending, didResolveAny, resolvedChanges };
    }
}
